export default "__VITE_ASSET__DbaGtH0F__"